export type ClipQuota = {
  limit: number | null;
  used: number;
  nextAvailableAt: string | null;
};

export const isAtClipLimit = (clipQuota: ClipQuota | undefined): boolean => {
  if (!clipQuota || clipQuota.limit === null) return false;
  return clipQuota.used >= clipQuota.limit;
};
